import "./es.object.assign-7e79fd7b.js";
import { c as a } from "./index-8b07dec9.js";
import { createContext as X, useContext as Y, useRef as Z, useState as E, useEffect as K, useCallback as B } from "react";
import d, { css as p } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as oo } from "./getMetrics-953aa4f8.js";
import { _ as io } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import { getAriaProps as to } from "./aria.js";
import { _ as no } from "./cloneSlots-622cf8c9.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as ro, UseSlotsPickType as eo } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { e as W, D as k } from "./index-f5b44da3.js";
import { a as co } from "./index-5d0f31c6.js";
import { jsxs as f, jsx as r } from "react/jsx-runtime";
import { A as mo, m as ao } from "./index-55eee02a.js";
import { A as po } from "./accordionPanel-89132988.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.symbol.description-6025a604.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./inherit-if-required-f068457b.js";
import "./es.regexp.to-string-e800d529.js";
import "./set-species-5ede2ed0.js";
import "./es.string.search-d27ec57a.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.array.from-fe752fa6.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./es.function.name-b230e7d4.js";
import "./es.date.to-string-6ed49878.js";
import "./es.parse-float-020a2ae0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/ucl-translation";
import "react-dom";
import "./useWindowSize.js";
import "./helperText.js";
import "./es.array.join-c1bca812.js";
import "./uniqueId.js";
import "./es.global-this-a7f40ce1.js";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./label.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./popupTip-06ee114c.js";
import "./usePopoverIndex.js";
import "./button.js";
import "./combineRefs-c9ad2c39.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./iconButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./string-html-forced-a746405b.js";
import "./tooltip.js";
import "./carousel.js";
import "./useMediaQuery.js";
import "./index-f2264f1e.js";
import "./screenReaderOnly.js";
import "./accessibility.js";
import "./text.js";
import "./link.js";
import "./badge.js";
import "./es.string.small-23219181.js";
import "./an-instance-6efcfd6c.js";
import "@ucl/shared-icons";
import "./tslib.es6-59e1c9d8.js";
var R = /* @__PURE__ */ X({}), so = ["children", "title", "subTitle", "id", "icon", "boxVariation", "disabled", "inactive", "isAnimate", "openAccordion", "setOpenAccordion", "accessibilityOptions", "className", "dataTestId", "_isDropDownMenu", "_dropDownProps", "headingLevel"], lo = /* @__PURE__ */ d.div.withConfig({
  displayName: "accordionItem__StyledAccordionItem",
  componentId: "sc-1mmjtym-0"
})(["&.AccordionItem{", ";}"], function(i) {
  var o = i.theme.components.accordion;
  return p(o.AccordionItem);
}), uo = /* @__PURE__ */ d.div.withConfig({
  displayName: "accordionItem__Summary",
  componentId: "sc-1mmjtym-1"
})(["&.AccordionItem__summary{", ";}"], function(i) {
  var o = i.theme.components.accordion;
  return p(o.Summary);
}), Io = /* @__PURE__ */ d.div.withConfig({
  displayName: "accordionItem__TitleWrapper",
  componentId: "sc-1mmjtym-2"
})(["&.AccordionItem__summary-title-wrapper{", ";}"], function(i) {
  var o = i.theme.components.accordion;
  return p(o.TitleWrapper);
}), Ao = /* @__PURE__ */ d.div.withConfig({
  displayName: "accordionItem__LeadingIcon",
  componentId: "sc-1mmjtym-3"
})(["&.AccordionItem__summary-leading-icon{", ";}"], function(i) {
  var o = i.theme.components.accordion;
  return p(o.LeadingIcon);
}), _o = /* @__PURE__ */ d.div.withConfig({
  displayName: "accordionItem__Title",
  componentId: "sc-1mmjtym-4"
})(["&.AccordionItem__summary-title{", ";}"], function(i) {
  var o = i.theme.components.accordion;
  return p(o.Title);
}), vo = /* @__PURE__ */ d.h5.withConfig({
  displayName: "accordionItem__TitleContent",
  componentId: "sc-1mmjtym-5"
})(["&.Accordion__title-content{", ";}"], function(i) {
  var o = i.theme.components.accordion;
  return p(o.TitleContent);
}), yo = /* @__PURE__ */ d.span.withConfig({
  displayName: "accordionItem__TrailingIcon",
  componentId: "sc-1mmjtym-6"
})(["&.AccordionItem__summary-trailing-icon{", ";}"], function(i) {
  var o = i.theme.components.accordion;
  return p(o.TrailingIcon);
}), ho = /* @__PURE__ */ d(ao.div).withConfig({
  displayName: "accordionItem__Content",
  componentId: "sc-1mmjtym-7"
})(["&.AccordionItem__content{", ";}"], function(i) {
  var o = i.theme.components.accordion;
  return p(o.Content);
}), go = function(o) {
  var u, I = o.children, b = o.title, A = o.subTitle, e = o.id, h = o.icon, w = o.boxVariation, n = o.disabled, l = o.inactive, _ = o.isAnimate, N = _ === void 0 ? !0 : _, c = o.openAccordion, S = o.setOpenAccordion, O = o.accessibilityOptions, q = O === void 0 ? {} : O, z = o.className, F = o.dataTestId, C = o._isDropDownMenu, s = o._dropDownProps, G = o.headingLevel, H = io(o, so), g = Y(R), x = g.activeAccordionItemId, j = g.setActiveAccordionItemId, v = g.isSingleSelect, P = g.isBoxVariant, V = P === void 0 ? w : P, J = Z(null), L = E(typeof c > "u" && v ? x === e : c), m = L[0], M = L[1], $ = ro(I, {
    tags: W
  }, eo.LAST);
  K(function() {
    M(typeof c > "u" && v ? x === e : c);
  }, [c, v, x, e]);
  var T = B(function(t) {
    if (!(l || n)) {
      var y = t.currentTarget.dataset.itemId;
      typeof c > "u" && v && j(function(D) {
        return D === y ? null : y;
      }), typeof c > "u" && M(function(D) {
        return !D;
      }), S == null || S(t, y, !m);
    }
  }, [l, n, v, c, m, j, S]), Q = B(function(t) {
    (t.code === "Enter" || t.code === "Space") && (t.preventDefault(), T(t));
  }, [T]);
  return /* @__PURE__ */ f(lo, Object.assign({
    className: a(["AccordionItem", {
      "AccordionItem--disabled": n,
      "AccordionItem--inactive": l,
      "AccordionItem--box": V
    }]),
    ref: J,
    "data-testid": F
  }, H, {
    children: [/* @__PURE__ */ f(uo, Object.assign({
      role: "button",
      "aria-expanded": !!m,
      "aria-controls": "accordion-content-" + e,
      "aria-disabled": n || !1
    }, to("button", q), {
      tabIndex: n ? void 0 : 0,
      className: a(["AccordionItem__summary", {
        "AccordionItem__summary--disabled": n,
        "AccordionItem__summary--inactive": l,
        "AccordionItem__summary--box": V,
        "AccordionItem__summary--open": m,
        "AccordionItem__summary--dropdown": C
      }, z]),
      "data-item-id": e,
      onKeyDown: Q,
      onClick: n ? void 0 : T,
      children: [/* @__PURE__ */ f(Io, {
        className: a(["AccordionItem__summary-title-wrapper", {
          "AccordionItem__summary-title-wrapper--disabled": n,
          "AccordionItem__summary-title-wrapper--open": m,
          "AccordionItem__summary-title-wrapper--dropdown": C
        }]),
        children: [h && /* @__PURE__ */ r(Ao, {
          "data-component": "accordion-icon-wrapper",
          className: a(["AccordionItem__summary-leading-icon", {
            "AccordionItem__summary-leading-icon--disabled": n
          }]),
          children: h
        }), /* @__PURE__ */ f(_o, {
          className: a(["AccordionItem__summary-title", {
            "AccordionItem__summary-title--disabled": n,
            "AccordionItem__summary-title--open": m
          }]),
          children: [no($.tags, function(t, y) {
            return /* @__PURE__ */ r(W, {
              title: t.title,
              className: "accordion-title-tag"
            }, y);
          }), /* @__PURE__ */ r(vo, {
            as: G,
            className: a("Accordion__title-content"),
            "data-component": "accordion-title-wrapper",
            children: b
          }), A && [].concat(A).filter(Boolean).map(function(t) {
            return /* @__PURE__ */ r("h6", {
              children: t
            });
          })]
        }), !l && /* @__PURE__ */ r(yo, {
          className: a(["AccordionItem__summary-trailing-icon", {
            "AccordionItem__summary-trailing-icon--disabled": n,
            "AccordionItem__summary-trailing-icon--animate": N,
            "AccordionItem__summary-trailing-icon--open": m
          }]),
          children: /* @__PURE__ */ r(co, {
            icon: "caretUp",
            "aria-hidden": !1,
            className: "trailing-icon"
          })
        })]
      }), C && /* @__PURE__ */ r(k, {
        className: "AccordionItem__summary-dropdown",
        closeOnSelect: s == null ? void 0 : s.closeOnSelect,
        menuDirection: s == null ? void 0 : s.menuDirection,
        onChange: s == null ? void 0 : s.onChange,
        children: s == null || (u = s.items) == null ? void 0 : u.map(function(t) {
          return /* @__PURE__ */ r(k.Item, {
            label: t.label,
            value: t.value
          }, t.label);
        })
      })]
    })), /* @__PURE__ */ r(mo, {
      children: m && /* @__PURE__ */ r(ho, {
        initial: "collapsed",
        animate: m ? "open" : "collapsed",
        exit: "collapsed",
        variants: {
          open: {
            height: "auto",
            transitionEnd: {
              overflow: "unset"
            }
          },
          collapsed: {
            height: 0,
            overflow: "hidden"
          }
        },
        transition: {
          duration: 0.3,
          ease: "easeInOut"
        },
        "aria-labelledby": "accordion-content-" + e,
        id: "accordion-content-" + e,
        className: a(["AccordionItem__content", {
          "AccordionItem__content--disabled": n
        }]),
        "aria-hidden": !m,
        children: $.rest
      }, "content")
    })]
  }));
}, fo = /* @__PURE__ */ d.div.withConfig({
  displayName: "accordion__StyledAccordion",
  componentId: "sc-1oc4er2-0"
})(["&.Accordion{", ";}"], function(i) {
  var o = i.theme, u = o.componentStyles, I = o.components.accordion;
  return p(I.AccordionContainer, u);
}), U = function(o) {
  var u = o.children, I = o.boxVariation, b = o.singleSelect, A = o.activeAccordionItemId, e = A === void 0 ? null : A, h = o.className, w = o.containerId, n = o.dataTestId, l = oo({
    label: "Accordion"
  }), _ = E(e), N = _[0], c = _[1];
  return K(function() {
    c(e);
  }, [e]), /* @__PURE__ */ r(R.Provider, {
    value: {
      isBoxVariant: I,
      isSingleSelect: b,
      activeAccordionItemId: N,
      setActiveAccordionItemId: c
    },
    children: /* @__PURE__ */ r(fo, Object.assign({
      id: w,
      "data-testid": n,
      className: a(["Accordion", {
        "Accordion--box": I
      }, h])
    }, l, {
      children: u
    }))
  });
};
U.Item = go;
U.Panel = po;
export {
  U as Accordion,
  go as AccordionItem,
  po as AccordionPanel
};
